import { ProjectsTableColumnField } from "@components/table/projects/projects-table-types";
import { SvgIcon, SvgIconProps } from "@mui/material";
import HoloBuilderIcon from "@assets/icons/new/holobuilder_36px.svg?react";
import ViewerIcon from "@assets/icons/new/open-in-viewer.svg?react";
import { UI_HEIGHTS_VIRTUALIZATION_GRID } from "@styles/common-styles";
import { ColumnConfig } from "@components/virtualized/virtualized-grid-utils";

export function ViewerMuiIcon(props: SvgIconProps): JSX.Element {
  return <SvgIcon component={ViewerIcon} inheritViewBox {...props} />;
}

export function HoloBuilderMuiIcon(props: SvgIconProps): JSX.Element {
  return <SvgIcon component={HoloBuilderIcon} inheritViewBox {...props} />;
}

/** Columns to be displayed in the projects table */
export const requiredProjectTableColumns: ProjectsTableColumnField[] = [
  "name",
  "projectManager",
  "group",
  "created",
  "lastCaptured",
  "lastUpdated",
  "client",
  "size",
  "accessLevel",
  "options",
];

/**
 * Total vertical UI height above the VirtualizedGrid.
 * The grid fills the rest of the viewport height.
 */
export const VIRTUAL_GRID_OFFSET_MOBILE =
  UI_HEIGHTS_VIRTUALIZATION_GRID.appBar +
  UI_HEIGHTS_VIRTUALIZATION_GRID.tabBar +
  UI_HEIGHTS_VIRTUALIZATION_GRID.projects.mobile.actionBar +
  UI_HEIGHTS_VIRTUALIZATION_GRID.contentPadding +
  UI_HEIGHTS_VIRTUALIZATION_GRID.paddingTiles;

/**
 * Config for mobile: forces 1 column at all sizes.
 * Only need to define what differs from defaults.
 */
export const customColumnMobileConfig: ColumnConfig = {
  xs: 1,
  sm: 1,
  md: 1,
  lg: 1,
  xl: 1,
  xxl: 1,
  xxxl: 1,
};
